export default __webpack_public_path__ + "static/media/TonIK.c2d68620.pdf";